import { Icon } from '../Icon';

export interface RenderedTrustBadge {
  label: string;
  bg: string;
  text: string;
  border: string;
  icon: string;
}

export interface VBCTrustBadgesProps {
  badges: RenderedTrustBadge[];
}

/**
 * Renders trust badge pills (PRO, VERIFIED, VALIDATED, CLAIMED).
 * Server Component — no interactivity needed.
 */
export function VBCTrustBadges({ badges }: VBCTrustBadgesProps) {
  if (badges.length === 0) return null;

  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {badges.filter(badge => badge.label !== 'VALIDATED').map((badge) => {
        return (
          <span
            key={badge.label}
            className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1"
            style={{
              backgroundColor: badge.bg,
              color: badge.text,
              borderColor: badge.border,
              fontSize: '11px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            <Icon name={badge.icon} size={13} />
            {badge.label}
          </span>
        );
      })}
    </div>
  );
}
